var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chartdata)?_c('span',{staticClass:"alarmeJeMonat"},[(_vm.loaded)?_c('line-chart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options}}):_vm._e()],1):(!_vm.chartdata && !_vm.loaded)?_c('div',{staticClass:"text-center"},[_c('SpinnerImage')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }